module.exports = __webpack_public_path__ + "assets/b2a407e54a77cfec601ecac03264eb32.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/coins/bet+4.mp3
 ** module id = 321
 ** module chunks = 0
 **/